import { isBefore } from 'date-fns';

export const isStartDateInvalid = (startDate: string) => {
	if (!startDate) return false;
	const day = startDate.split('-')[2];
	const mounth = startDate.split('-')[1];
	const year = startDate.split('-')[0];

	const today = new Date();
	const start = new Date(`${year}-${mounth}-${day}`);
	start.setDate(Number(day));
	start.setMonth(Number(mounth) - 1);
	// Zera horas para comparar só a data
	today.setHours(0, 0, 0, 0);
	start.setHours(0, 0, 0, 0);
	return isBefore(start, today);
};

export const isEndDateInvalid = (startDate: string, endDate: string) => {
	if (!endDate || !startDate) return false;
	const start = new Date(startDate);
	const end = new Date(endDate.split('T')[0]);
	return isBefore(end, start);
};

export const isStartTimeInvalid = (startDate: string, startTime: string) => {
	if (!startDate || !startTime) return false;
	const today = new Date();
	const start = new Date(`${startDate.split('T')[0]}T${startTime}`);
	if (isBefore(start, today)) {
		// Só invalida se for hoje
		const todayStr = today.toISOString().split('T')[0];
		return startDate.split('T')[0] === todayStr;
	}
	return false;
};

export const isEndTimeInvalid = (
	startDate: string,
	startTime: string,
	endDate: string,
	endTime: string
) => {
	if (!startDate || !startTime || !endDate || !endTime) return false;
	const start = new Date(`${startDate.split('T')[0]}T${startTime}`);
	const end = new Date(`${endDate.split('T')[0]}T${endTime}`);
	return isBefore(end, start);
};

export const isValidDateAndTime = (dateStr: string) => {
	if (!dateStr) return false;
	const [datePart, timePart] = dateStr.split('T');
	if (!datePart || !timePart) return false;

	const date = new Date(datePart);
	const timeParts = timePart.split(':');
	if (timeParts.length < 2) return false;

	const hours = parseInt(timeParts[0], 10);
	const minutes = parseInt(timeParts[1], 10);
	if (isNaN(hours) || isNaN(minutes)) return false;

	date.setHours(hours, minutes, 0, 0);
	return !isNaN(date.getTime());
};

export const getDateAndTime = (dateStr: string) => {
	const [datePart, timePart] = dateStr ? dateStr.split('T') : ['', ''];
	return { datePart, timePart: timePart || '' };
};

export const mergeDateAndTime = (dateISO: string, time: string) => {
	if (!dateISO) return '';
	const datePart = dateISO.split('T')[0];
	return `${datePart}T${time}`;
};
